import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({ baseURL: API_URL });

// Flag to stop all subsequent requests instantly once a 401 is encountered
let isSessionExpired = false;

// Attach the current auth token to every outgoing request; block everything once the session is known-expired
api.interceptors.request.use((config) => {
  if (isSessionExpired) {
    return Promise.reject(new axios.Cancel('Session expired, request blocked to prevent fail2ban'));
  }
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A 401 from the backend means the token is dead — wipe it and force back to the login screen
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !isSessionExpired) {
      isSessionExpired = true;
      console.warn('Ghost or expired session detected globally. Locking requests.');
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
